import {
  Card,
  CardContent,
  Box,
  Skeleton,
  Divider,
  CardHeader,
  Typography,
  Chip,
  LinearProgress,
  Tooltip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { CalendarToday } from "@mui/icons-material";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import { ConvertDate } from "../../../Base/helper/baseFunctions";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useState } from "react";

const PerformanceCard = ({ checkin, handleCheckinPopup, value }) => {
    const [anchorE, setAnchorE] = useState(null);
    const open1 = Boolean(anchorE);
    const [currentData, setCurrentData] = useState(null);
    const handleHorMorevertClick = (event, data) => {
      setCurrentData(data);
      setAnchorE(event.currentTarget);
    };
  return (
    <>
      <Card
        sx={{
          borderRadius: 3,
          boxShadow: 2,
          minHeight: 220,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {/* Header */}
        <CardHeader
          sx={{ py: 1.5, px: 1.5 }}
          title={
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Chip
                label={checkin?.checkin_type}
                size="small"
                sx={{
                  fontSize: "0.75rem",
                  fontWeight: "bold",
                  backgroundColor: "#E8F5E9",
                  color: "#2E7D32",
                }}
              />
              <Box sx={{display: "flex", alignItems: "center", gap: "10px"}}>
                  <Tooltip title={"Preview"}>
                    <VisibilityIcon
                      onClick={() => handleCheckinPopup(checkin, "Preview")}
                      fontSize="small"
                      sx={{ color: "grey.600", cursor: "pointer" }}
                    />
                  </Tooltip>
                  {value === "1" && (<Tooltip title="More Options">
                      <MoreHorizIcon 
                        onClick={(event) => handleHorMorevertClick(event, checkin)}
                        fontSize="small" color="action" sx={{ cursor: "pointer"}} />
                  </Tooltip>)}
                </Box>
            </Box>
          }
        />

        {/* Title & Description */}
        <CardContent sx={{ pt: 0, px: 2, pb: 1 }}>
          <Typography
            variant="subtitle1"
            fontWeight={600}
            sx={{
              display: "-webkit-box",
              WebkitLineClamp: 1,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {checkin?.checkin_title}
          </Typography>

          {/* <Typography
            variant="body2"
            color="text.secondary"
            gutterBottom
            sx={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {checkin?.checkin_comments}
          </Typography> */}
          <Box display="flex" alignItems="center" gap={0.5} mb={1}>
            <CalendarToday color="disabled" sx={{ width: 20, height: 20 }} />
            <Typography variant="caption">
              {ConvertDate(checkin?.checkin_start_date)}
            </Typography>
            <Typography variant="caption">
              -
            </Typography>
            <Typography variant="caption">
              {ConvertDate(checkin?.checkin_end_date)}
            </Typography>
          </Box>
          {/* Progress bar */}
          <Box>
            <Typography variant="body2" fontWeight={500} mb={0.5}>
              Progress {checkin?.checkin_progress}
            </Typography>
            <LinearProgress
              variant="determinate"
              value={parseInt(checkin?.checkin_progress)}
              sx={{
                height: 8,
                borderRadius: 5,
                backgroundColor: "#E5E7EB",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: "#66BB6A",
                },
              }}
            />
          </Box>
        </CardContent>

        <Divider sx={{ borderBottomWidth: 2, width: "90%", margin: "auto" }} />

        {/* Footer */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          px={2}
          pb={1}
          pt={1}
        >
          <Box display="flex" flexDirection={"column"} alignItems="start" gap={1} width={"100%"}>
            <Typography variant="body2" fontWeight={500} mb={"-4px"}>
              Related Goal
            </Typography>
              <Chip
                label={checkin?.goal_sub_category_name}
                size="small"
                sx={{ mr: 0.5, fontSize: "0.7rem" }}
              />
          </Box>
        </Box>
      </Card>
       <Menu
          anchorEl={anchorE}
          open={open1}
          onClose={() => setAnchorE(null)}
          id="long-menu"
        >
          <MenuItem
            key="Edit"
            onClick={() => handleCheckinPopup(currentData, "Edit")}
          >
            <ListItemIcon>
              <DriveFileRenameOutlineIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Edit</ListItemText>
          </MenuItem>
          <MenuItem
            key="Delete"
            onClick={() => handleCheckinPopup(currentData, "Delete")}
          >
            <ListItemIcon>
              <DeleteIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Delete</ListItemText>
          </MenuItem>
        </Menu>
    </>
  );
};

// Skeleton Loader
export const CheckinCardSkeleton = () => {
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: 2,
        height: 220,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      {/* Header */}
      <CardContent sx={{ py: 1.5, px: 1.5 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" gap={1}>
          <Skeleton variant="rounded" width={50} height={20} />
          <Box display="flex" gap={1}>
            <Skeleton variant="circular" width={20} height={20} />
            <Skeleton variant="circular" width={20} height={20} />
          </Box>
        </Box>
      </CardContent>

      {/* Title & Description */}
      <CardContent sx={{ py: 0, px: 2 }}>
        <Skeleton variant="text" width="70%" height={24} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="100%" height={18} sx={{ mb: 0.5 }} />
        <Skeleton variant="text" width="90%" height={18} />

        {/* Progress */}
        <Box mt={1}>
          <Skeleton variant="text" width="40%" height={18} sx={{ mb: 0.5 }} />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={8}
            sx={{ borderRadius: 5 }}
          />
        </Box>
      </CardContent>

      <Divider sx={{ borderBottomWidth: 2, width: "90%", margin: "auto" }} />

      {/* Footer */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px={2}
        pb={1.5}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Skeleton variant="circular" width={22} height={22} />
          <Skeleton variant="rounded" width={100} height={20} />
        </Box>
        <Box display="flex" alignItems="center" gap={0.5}>
          <Skeleton variant="circular" width={20} height={20} />
          <Skeleton variant="text" width={50} height={14} />
        </Box>
      </Box>
    </Card>
  );
};





export default PerformanceCard;